var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg0202D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 561,
    viewBox: "0 0 1000 561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #000;\r\n        stroke-width: 20px;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157,192s-77.682-45.619-90-53c40.2-82.041,122.091-99,177-99,84.013,0,172,37.083,172,133s-55.3,140.281-65,151-91,92-91,92H427V521H88V438S227.091,300.005,263,263c29.553-30.455,45.336-89.6,6-111.08-14.249-7.78-46.923-8.331-63-.92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_copy",
    "data-name": "Shape 2 copy",
    className: "cls-1",
    d: "M488,157V49H698c122.032,0,239,84.078,239,221S861.372,522,701,522H487V208H611V414h86c55.869,0,116-31.092,116-141S719.143,156,698,156H580.013"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0202D);
export default __webpack_public_path__ + "static/media/020_2D.fa2c746f9d05c06f5e3ec03def6b7e55.svg";
export { ForwardRef as ReactComponent };